const snotify_config = {
 toast: {
  timeout: 10000,
  // timeout: 75000, // testing really long timeout
  closeOnClick: true,
  pauseOnHover: true,
  titleMaxLength: 32,
  bodyMaxLength: 400,
  position: 'rightTop'
 }
};

export default snotify_config;
